export default __webpack_public_path__ + "static/media/val3.805c3256.png";